import React, { useContext, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Row, Card, Form, Input, Col, Button, Spin, Typography } from 'antd'
import { EmptyHeaderHero } from './components'
import { UserContext } from '../context'
import { updatePassword, verifyLogin } from '../services'
import { useWindowSize, getDomain } from '../utils'
import { useRouter } from 'next/router'

import TempPasswordStyle from '../../styles/TempPassword.module.css'

const { Text } = Typography
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const TempPassword = (props) => {
  const router = useRouter();
  const [newPassword, setNewPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [passwordResetMessage, setPasswordResetMessage] = useState(null)
  const [showLogin, setShowLogin] = useState(null)
  const [loginApiResponseMessage, setLoginApiResponseMessage] = useState()
  const [password, setPassword] = useState('')
  const [tempPassword, setTempPassword] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)
  const [, dispatch] = useContext(UserContext)
  const [emailAddress, setEmailAddress] = useState(null)

  const windowSize = useWindowSize()
  const isMobile = windowSize.width > 1024

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || null)

    if (user) {
      dispatch({
        type: 'ADD_EMAIL',
        payload: {
          ...user
        }
      })
      setEmailAddress(user.emailAddress)
      setTempPassword(user.tempPassword)
    } else {
      window.location = '/my-account'
    }
  }, [dispatch])

  const validateUserPassword = (newPassword, retypePassword) => {
    let response = true
    if (newPassword !== retypePassword) {
      response = false
    }
    return response
  }

  const handleUpdatePassword = async () => {
    console.log(router)
    var userData = router.query
    
    setShowLogin(false)
    const validationResponse = validateUserPassword(newPassword, retypePassword)
    if (validationResponse) {
      const response = await updatePassword({
        EmailAddress: emailAddress,
        NewPassword: newPassword,
        TempPassword: tempPassword,
        PolicyNumber: userData.PolicyNumber,
        ZipCode: userData.Zip
      })
      setPasswordResetMessage(response.data.Result)
      dispatch({
        type: 'REMOVE_EMAIL',
        payload: {
          emailAddress: null
        }
      })
      if (response.data.Result === 'Success') {
        setShowLogin(true)
      }
    }
  }

  const validateConfirmPassword = () => {
    let response = false
    if (newPassword.length === 0 || retypePassword.length === 0) {
      response = true
    } else if (newPassword.length > 0 && retypePassword.length > 0) {
      if (newPassword === retypePassword) {
        const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
        if (!isValidLength.test(newPassword)) {
          response = true
        } else {
          response = false
        }
      } else {
        response = true
      }
    }
    return response
  }

  const validatePassword = () => {
    const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
    let response = false
    if (password.length === 0) {
      response = true
    } else if (password.length > 0) {
      if (!isValidLength.test(password)) {
        response = true
      } else {
        response = false
      }
    }
    return response
  }

  const loginWithCurrentEmail = async () => {
    setShowSpinner(true)
    setLoginApiResponseMessage(null)
    const validationResponse = validatePassword()
    if (!validationResponse) {
      const response = await verifyLogin(emailAddress, password, 'login')
      if (response && response.data) {
        setPassword('')
        setPasswordResetMessage('')
        const { Result, Tkn } = response.data
        setLoginApiResponseMessage(Result)
        if (Result === 'Success') {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        }
      }
    } else {
      setLoginApiResponseMessage('Not Found')
      setShowSpinner(false)
    }
  }

  const handleChangePasswordKeyDown = event => {
    if (event.key === 'Enter' && !validateConfirmPassword()) {
      handleUpdatePassword()
    }
  }

  const handleNewPasswordKeyDown = event => {
    if (event.key === 'Enter') {
      loginWithCurrentEmail()
    }
  }

  return (
    <>
      <EmptyHeaderHero title="Reset Your Password" />
      <div className={`${TempPasswordStyle["forgot-password-screen"]}`}>
        <Row>
          <Card className={`${TempPasswordStyle["forgot-password-card"]}`}>
            {emailAddress && !showLogin && (
              <div>
                <h5 className={`${TempPasswordStyle["sub-label"]}`}>Set your new password.</h5>
                {isMobile && (
                  <h4 className={`${TempPasswordStyle["sub-label"]}`}>
                    Your Username (Email):&nbsp;&nbsp;&nbsp;
                    <span>{emailAddress}</span>
                  </h4>
                )}
                {!isMobile && (
                  <h4 className={`${TempPasswordStyle["sub-label"]} ${TempPasswordStyle["email"]}`}>
                    Your Username (Email): <span>{emailAddress}</span>
                  </h4>
                )}
                <h4 className={`${TempPasswordStyle["sub-label"]} ${TempPasswordStyle["email"]}`}>
                  Passwords must have at least 5 characters with 1 number and 1 capital letter.
                </h4>
                <Row>
                  <Col className={`${TempPasswordStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${TempPasswordStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setNewPassword(event.target.value)}
                        onKeyDown={handleChangePasswordKeyDown}
                        placeholder="Password*"
                        type="password"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${TempPasswordStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${TempPasswordStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setRetypePassword(event.target.value)}
                        onKeyDown={handleChangePasswordKeyDown}
                        placeholder="Confirm Password*"
                        type="password"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {passwordResetMessage && (
                  <Row className={`${TempPasswordStyle["margin-bottom-8"]}`}>
                    <Col
                      className={`${TempPasswordStyle["account-margin-select"]}`}
                      lg={{ span: 12 }}
                      md={{ span: 12 }}
                      xl={{ span: 12 }}
                      xs={{ span: 24 }}
                    >
                      {passwordResetMessage !== 'Success' && <Text className={`${TempPasswordStyle["error-msg"]}`}>{passwordResetMessage}</Text>}
                      {passwordResetMessage === 'Success' && (
                        <Text className={`${TempPasswordStyle["success-msg"]}`}>Thank you. You have successfully changed your password.</Text>
                      )}
                    </Col>
                  </Row>
                )}
                <Row className={`${TempPasswordStyle["desktop-width-380"]}`} justify="center">
                  <Col className={`${TempPasswordStyle["account-margin"]}`}>
                    <Form.Item className={`${TempPasswordStyle["btn-control"]}`}>
                      <Button
                        className={`${TempPasswordStyle["submit"]} ${TempPasswordStyle["submit-form-button"]} ${TempPasswordStyle["desktop-width-128"]}`}
                        disabled={validateConfirmPassword()}
                        onClick={handleUpdatePassword}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
            {showLogin && (
              <div>
                <h5 className={`${TempPasswordStyle["sub-label"]}`}>Log in with your new password.</h5>
                {isMobile && (
                  <h4 className={`${TempPasswordStyle["sub-label"]} ${TempPasswordStyle["email"]}`}>
                    Your Username (Email):&nbsp;&nbsp;&nbsp;
                    <span>{emailAddress}</span>
                  </h4>
                )}
                {!isMobile && (
                  <h4 className={`${TempPasswordStyle["sub-label"]} ${TempPasswordStyle["email"]}`}>
                    Your Username (Email): <span>{emailAddress}</span>
                  </h4>
                )}
                {passwordResetMessage === 'Success' && (
                  <Text className={`${TempPasswordStyle["success-msg"]} ${TempPasswordStyle["margin-bottom-12"]}`}>
                    Thank you. You have successfully changed your password.
                  </Text>
                )}
                <Row>
                  <Col className={`${TempPasswordStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input
                        autoComplete="off"
                        className={`${TempPasswordStyle["input-text"]} ${TempPasswordStyle["dark-text"]}`}
                        disabled
                        onKeyDown={handleNewPasswordKeyDown}
                        placeholder="Email Address"
                        value={emailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${TempPasswordStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${TempPasswordStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setPassword(event.target.value)}
                        onKeyDown={handleNewPasswordKeyDown}
                        placeholder="Password*"
                        type="password"
                        value={password}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {loginApiResponseMessage === 'Not Found' && (
                  <Text className={`${TempPasswordStyle["error-msg"]}`}>Invalid email address or password.</Text>
                )}
                {loginApiResponseMessage !== 'Not Found' && showSpinner && (
                  <Text className={`${TempPasswordStyle["success-msg"]}`}>Success. Please wait ...</Text>
                )}
                {loginApiResponseMessage !== 'Not Found' && showSpinner && <Spin indicator={antIcon} />}
                <Row className={`${TempPasswordStyle["desktop-width-380"]}`}>
                  <Col className={`${TempPasswordStyle["account-margin"]}`} style={{ width: '100%', textAlign: 'center' }}>
                    <Form.Item className={`${TempPasswordStyle["btn-control"]}`}>
                      <Button className={`${TempPasswordStyle["submit"]} ${TempPasswordStyle["submit-form-button"]} ${TempPasswordStyle["desktop-width-128"]}`} onClick={loginWithCurrentEmail}>
                        Log In
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Row>
      </div>
    </>
  )
}

TempPassword.propTypes = {}

export default TempPassword
